import { connect } from 'react-redux';

import { IPrintPhotoProps, PrintPhoto } from '../../components/PrintPhoto';
import { IState } from '../../store';
import { getPhotos } from '../../utils/gallery_helpers';

export function mapStateToProps(state: IState): IPrintPhotoProps {
  return {
    photos: getPhotos(state),
  };
}

export const PrintPhotoContainer = connect<IPrintPhotoProps>(mapStateToProps)(PrintPhoto);
